import Vue from "vue";

class UserService {
    account = {
        type: {
            personal: "personal",
            enterprise: "enterprise",
        },
    };

    constructor() {}

    /**
     * @description To update payment information in account of user
     * @param {Object} data 
     * @returns 
     */
    async updatePaymentInfo(data = {}) {
        try {
            return await Vue.axios.post("/user/updateUserPaymentInfo", data);
        } catch (e) {
            return Promise.reject(e);
        }
    }

    /**
     * @description To update first name, last name, phone number 
     * and status update for general info of acccount 
     * 
     * @param {{firstName, lastName, mobile, accountType, enterpriseName, representativeName, position, website, isUpdateFirst}} data
     * @returns Promise 
     */
    async updateGeneralInfo(data = {}) {
        try {
            return await Vue.axios.post("/user/updateUserSettingsGeneral", data);
        } catch(e) {
            return Promise.reject(e);
        }
    }

    /**
     * @description To update first name, last name
     *
     * @param {{firstName, lastName}} data
     * @returns Promise
     */
    async updateFirstLastNameUserSettingsGeneral(data = {}) {
        try {
            return await Vue.axios.post("/user/updateFirstLastNameUserSettingsGeneral", data);
        } catch (e) {
            return Promise.reject(e);
        }
    }

    /**
     * @description To update phone
     *
     * @param {{phone}} data
     * @returns Promise
     */
    async updatePhoneUserSettingsGeneral(data = {}) {
        try {
            return await Vue.axios.post("/user/updatePhoneUserSettingsGeneral", data);
        } catch (e) {
            return Promise.reject(e);
        }
    }

    /**
     * @description To update enterpriseName, representativeName, position, website
     *
     * @param {{enterpriseName, representativeName, position, website}} data
     * @returns Promise
     */
    async updateEnterpriseSettingsGeneral(data = {}) {
        try {
            return await Vue.axios.post("/user/updateEnterpriseSettingsGeneral", data);
        } catch (e) {
            return Promise.reject(e);
        }
    }

    /**
     * @description To update password of user account
     * @param {{old_password, new_password, confirm_new_password}} data 
     * @returns Promise
     */
    async updatePasswordInfo(data = {}) {
        try {
            return await Vue.axios.post("/user/updateUserSettingsChangePassword", data);   
        } catch(e) {
            return Promise.reject(e);
        }
    }

    /**
     * @description TO get update request of user account
     * @param {{ status }} data 
     * @returns Promise
     */
    async getUpdateRequest(data = { status: 0 }) {
        try {
            return await Vue.axios.get(`/user/getUpdateRequests`, {
                params: { status: data.status || 0 },
            });
        } catch(e) {
            return Promise.reject(e);
        }
    }
    /**
     * @description To update password of user account
     * @param {{old_email,new_email,password,type}} data
     * @returns Promise
     */
    async onRequestChangeEmail(data = {}) {
        try {
            return await Vue.axios.post("/user/change-email/", data);
        } catch (e) {
            return Promise.reject(e);
        }
    }
    /**
     * @description TO verify email
     * @param  data
     * @returns Promise
     */
    async onVerifyChangeEmail(data = {}) {
        try {
            return await Vue.axios.get(`/user/change-email/${data.type}/${data.verifyCode}`);
        } catch (e) {
            return Promise.reject(e);
        }
    }
    /**
     * @description push notification when timout
     * @param  {{verifyCode, email}}data
     * @returns Promise
     */
    async timeoutChangeEmail(data = {}) {
        try {
            return await Vue.axios.post("/user/change-email/timeout/", data);
        } catch (e) {
            return Promise.reject(e);
        }
    }
    /**
     * @description TO reject email
     * @param  {{rejectCode}}data
     * @returns Promise
     */
    async onRejectChangeEmail(data = {}) {
        try {
            return await Vue.axios.get(`/user/change-email/old_email/reject/${data.rejectCode}`);
        } catch (e) {
            return Promise.reject(e);
        }
    }
}

const userService = new UserService();

export default userService;



// WEBPACK FOOTER //
// ./src/core/services/userService.js